import { render, staticRenderFns } from "./ExpiredWinnings.vue?vue&type=template&id=f4d7ddd4&scoped=true&"
import script from "./ExpiredWinnings.vue?vue&type=script&lang=js&"
export * from "./ExpiredWinnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d7ddd4",
  null
  
)

export default component.exports